/* Embroidery Inc homepage 2026-10: click-to-play cover for the order video (#order-demo).
   The <video> ships with preload="none"; bytes start loading on hover/focus intent or on click. */
(function () {
  /* Sections marked data-ei-cv use content-visibility: auto, so one that has not been shown yet only
     holds an estimated height. Render the ones above the target first so the scroll lands exactly. */
  function settle(target) {
    var cv = document.querySelectorAll('[data-ei-cv]');
    for (var i = 0; i < cv.length; i++) {
      if (cv[i].compareDocumentPosition(target) & 4) cv[i].style.contentVisibility = 'visible';
    }
  }

  /* In-page links (#id) scroll natively (the theme makes that smooth). Settle the estimated sections
     above the target first, so the browser computes the final spot from real heights. Registered once. */
  if (!window.__eiCvLinks) {
    window.__eiCvLinks = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a || !a.hash || a.hash.length < 2 || a.href.split('#')[0] !== location.href.split('#')[0]) return;
      var t;
      try { t = document.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (err) { return; }
      if (t) settle(t);
    }, true);
  }

  function init(frame) {
    var video = frame.querySelector('video');
    var cover = frame.querySelector('.ei-vid__cover');
    if (!video || !cover || frame.hasAttribute('data-ei-video-ready')) return;
    frame.setAttribute('data-ei-video-ready', '');

    var warm = function () { if (video.preload === 'none') video.preload = 'metadata'; };
    cover.addEventListener('pointerenter', warm, { once: true });
    cover.addEventListener('focus', warm, { once: true });

    var reveal = function () {
      frame.classList.remove('is-loading');
      frame.classList.add('is-playing');
      cover.setAttribute('tabindex', '-1');
      cover.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () { frame.classList.add('is-done'); }, 400);
    };

    cover.addEventListener('click', function () {
      frame.classList.add('is-loading');
      video.preload = 'auto';
      video.addEventListener('playing', reveal, { once: true });
      var p;
      try { p = video.play(); } catch (e) { p = null; }
      if (p && typeof p.then === 'function') {
        p.then(function () { try { video.focus({ preventScroll: true }); } catch (e) {} }, reveal);
      } else {
        reveal();
      }
      /* Safety net: never leave the cover up if playback is slow to start. */
      window.setTimeout(function () { if (!frame.classList.contains('is-playing')) reveal(); }, 6000);
    });
  }

  function run() { document.querySelectorAll('[data-ei-video]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
